/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { connect } from 'react-redux';
import config from '../../../../../../config';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '90vh',
    marginTop: theme.spacing(1),
  },
  mainTitle: {
    marginTop: '1em',
    textAlign: 'center',
  },
  image: {
    width: '35%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  textCard: {
    margin: '2em',
    padding: '2em',
  },
  titleword1: {
    color: theme.palette.primary.main,
  },
  titleword2: {
    color: theme.palette.secondary.main,
  },
  paragraph: {
    marginBottom: '20px',
    fontSize: 19,
    fontFamily: 'Arial',
    lineHeight: 1.5,
    textAlign: 'justify',
  },
  bold: {
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    padding: '0px 5px',
  },
}));

const LandingExamType2 = ({
  beginExamType2,
  setBeginExamType2,
  currentExam,
  additionalTime,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down('xs'));
  const getFormatedDate = (time) => `${time >= 60 ? `${Math.floor(time / 60)}h` : ''}${time % 60 > 0 ? `${Math.round(time % 60)}min` : ''}`;
  const examTime = getFormatedDate(currentExam.duration + parseInt(additionalTime, 10));

  const handleInitTest = async () => {
    setBeginExamType2(true);
  };
  return (
    <Grid container direction="row" justifyContent="center">
      <Grid item md={12}>
        <Typography className={classes.mainTitle} variant="h4">
          Bienvenue sur
          <span className={classes.titleword1}> Medical </span>
          <span className={classes.titleword2}>World </span>
        </Typography>
      </Grid>
      {!xs && (
      <Grid item md={12}>
        <img className={classes.image} alt="placement test illustration" src={`${config.OBJECT_URL}/thumbnail/pt-landing.svg`} />
      </Grid>
      )}
      <Grid item md={12} className={classes.textCard}>
        <Typography variant="body1" className={classes.paragraph}>
          Bonjour,
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          {`Votre épreuve va commencer et durera ${examTime}.`}
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          AVANT L&apos;EPREUVE :
        </Typography>
        <ul>
          <Typography component="li" style={{ fontSize: 19, lineHeight: 1.5 }} variant="body1">Désactiver tout &quot;Plug in&quot; de traduction (ex : Google translate) afin de garantir le bon fonctionnement de l’épreuve.</Typography>
          <Typography component="li" style={{ fontSize: 19, lineHeight: 1.5 }} variant="body1">Vérifier que votre ordinateur est à l&apos;heure.</Typography>
        </ul>
        <Typography variant="body1" className={classes.paragraph}>
          IMPORTANT :
        </Typography>
        <Typography variant="body1" className={classes.paragraph}>
          Dès que l&apos;examen démarrera, vous devrez télécharger votre sujet.
          {' '}
          Vous devrez ensuite rédiger votre réponse à l&apos;intérieur de l&apos;encadré prévu à cet effet. Une fois terminé, vous devrez cliquer sur le bouton &quot;envoyer&quot;.
          Attention cependant, tout envoi de réponse est définitif.
          En cas de difficultés, vous pouvez contacter l&apos;assistance au 07 67 50 74 15.
        </Typography>
      </Grid>
      <Button
        color="primary"
        variant="contained"
        style={{ marginBottom: '50px', fontSize: 19 }}
        onClick={() => handleInitTest()}
      >
        Commencer votre examen
      </Button>
    </Grid>
  );
};

function mapState(state) {
  const { additionalTime } = state.user.userData;
  return {
    additionalTime,
  };
}
export default connect(mapState, {})(LandingExamType2);
